<template>
    <v-card>
        <v-card-title>
            User events filter
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="4" style="height: 50px;">
                    <v-text-field v-model="userId" label="User ID" clearable outlined dense/>
                </v-col>
                <v-col cols="2" md="2" style="height: 50px;">
                    <v-select v-model="userEvent" :items="['Daily']" label="Event" clearable outlined dense small-chips/>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-text-field v-model="time" label="Time (sec)" clearable outlined dense/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12" style="height: 50px;">
                    <v-btn class="mr-4" @click="submit" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" style="height: 50px;">
                    <v-subheader>Time</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-text-field v-model="timeStart" label="start" hint="" persistent-hint clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-text-field v-model="timeEnd" label="end" hint="" persistent-hint clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-btn class="mr-4" @click="submitInt(timeStart, timeEnd, 'time')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" style="height: 50px;">
                    <v-subheader>Created</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-menu ref="menu1" v-model="dateStartMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="computedDateFormattedStart" label="start" persistent-hint prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on" clearable outlined dense/>
                        </template>
                        <v-date-picker v-model="dateStart" no-title @input="dateStartMenu = false"/>
                    </v-menu>
                </v-col>
                <v-col cols="2" class="d-flex align-center">
<!--                    <v-card flat height="50" width="20"><strong>-</strong></v-card>-->
                    <v-menu v-model="dateEndMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="computedDateFormattedEnd" label="end" persistent-hint prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on" clearable outlined dense/>
                        </template>
                        <v-date-picker v-model="dateEnd" no-title @input="dateEndMenu = false"/>
                    </v-menu>
                    <!--                        <p>Date in ISO format: <strong>{{ date }}</strong></p>-->
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-btn class="mr-4" @click="submitTimestamp(dateStart, dateEnd, 'created')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="12">
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            :items-per-page="25"
                            :search="search"
                            style="white-space: nowrap"
                    >
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Users</v-toolbar-title>
                                <v-divider class="mx-2" inset vertical/>
                                <!--                    <v-btn @click="createItem" class="ma-2" color="primary">-->
                                <!--                        New User-->
                                <!--                    </v-btn>-->
                                <v-spacer/>
                                <v-text-field
                                        append-icon="search"
                                        hide-details
                                        label="Search"
                                        single-line
                                        v-model.trim="search"
                                />
                            </v-toolbar>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
        <!--        <v-product-dialog ref="product-dialog"/>-->
    </v-card>
</template>

<script>
    import database from "../store/database";
    import dayJS from 'dayjs';
    import relativeTime from 'dayjs/plugin/relativeTime';
    import * as firebase from 'firebase/app'

    dayJS.extend(relativeTime);

    export default {
        name: "UserEvents",
        data: (vm) => ({
            search: "",
            headers: [
                { text: "Id", value: "userId"},
                { text: "Event", value: "userEvent"},
                { text: "Time", value: "time"},
                { text: "Date", value: "created"},
            ],
            items: [],

            userId: '',
            dateCreated:'',
            time:'',
            userEvent:'',

            timeStart:'',
            timeEnd:'',

            dateStart: '',//new Date().toISOString().substr(0, 10),
            dateEnd: '',//new Date().toISOString().substr(0, 10),
            dateUpdatedFormattedStart: '',//vm.formatDate(new Date().toISOString().substr(0, 10)),
            dateUpdatedFormattedEnd: '',//vm.formatDate(new Date().toISOString().substr(0, 10)),
            dateStartMenu: false,
            dateEndMenu: false,
        }),
        computed: {
            computedDateFormattedStart: {
                get: function () {
                    return this.formatDate(this.dateStart)
                },
                set: function (newValue) {
                    this.dateStart = newValue
                }
            },
            computedDateFormattedEnd : {
                get: function () {
                    return this.formatDate(this.dateEnd)
                },
                set: function (newValue) {
                    this.dateEnd = newValue
                }
            },
        },
        watch: {
            dateUpdatedStart (val) {
                this.dateUpdatedFormattedStart = this.formatDate(this.dateStart)
            },
            dateUpdatedEnd (val) {
                this.dateUpdatedFormattedEnd = this.formatDate(this.dateEnd)
            },
        },
        methods: {
            submit () {
                let collection = database.collection("user_events")
                if( this.userId ){
                    collection = collection.where("user_id", "==", this.userId)
                }
                if( this.dateCreated ){
                    collection = collection.where("created", "==", this.dateCreated)
                }
                if( this.userEvent ){
                    collection = collection.where("event", "==", this.userEvent)
                }
                if( this.time ){
                    collection = collection.where("time", "==", this.time)
                }
                this.getCollection(collection)
            },
            submitInt(startFrom, endFrom, fieldPath){
                let collection = database.collection("user_events")
                if( startFrom ){
                    collection = collection.where(fieldPath, ">=", parseInt(startFrom) )
                }
                if( endFrom ) {
                    collection = collection.where(fieldPath, "<=", parseInt(endFrom))
                }
                //collection = collection.orderBy("coins").limit(1)
                this.getCollection(collection)
            },
            submitTimestamp(from, to, fieldPath){
                let collection = database.collection("user_events")
                if( from ){
                    collection = collection.where(fieldPath, ">=", firebase.firestore.Timestamp.fromDate(new Date(from)))
                }
                if( to ) {
                    collection = collection.where(fieldPath, "<=", firebase.firestore.Timestamp.fromDate(new Date(to)).toDate())
                }
                //collection = collection.orderBy("coins").limit(1)
                //firebase.firestore.Timestamp.fromDate(new Date("December 10, 1815"))
                this.getCollection(collection)
            },
            getCollection(collection){
                this.items = []
                //.orderBy("created")
                collection.get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            //console.log(`${doc.id} => ${ Object.values(doc.data())}`);
                            this.items.push({
                                created: dayJS(doc.data().created.toDate()).fromNow(),
                                userId: doc.data().user_id,
                                time: doc.data().time,
                                userEvent: doc.data().event,
                            })
                        });
                    }).catch((error) => {
                    console.log(error)
                });  //store.getters["database/getProducts"];
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate (date) {
                if (!date) return null

                const [month, day, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
        },
        created() {
            //this.items = [] //store.getters["database/getProducts"];)
        }
    };
</script>